export interface PurchaseOrderHeaderLine {
  id: string;
  purchaseOrderHeaderId: string;
  purchaseOrderAndLineNo: string;
  sequence: number;
  status: string;
  productId: string;
  productType: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  quantity: number;
  unitOfMeasure: string;
  noOfItems: number;
  price: number;
  discount: number;
  lineValue: number;
  exStock: string;
  urgent: string;
  deliveryDate: Date;

  // todo - Added these fields to either show or hide the delete button on Sales-Order-lines grid. How can this be done in grid-component?
  canDelete: boolean;
  allocated: boolean;
  despatched: boolean;
  invoiced: boolean;
  colour: string;
}
